import {Button, Flex} from '@chakra-ui/react';
import {colors} from 'components/providers';
import {FC, PropsWithChildren} from 'react';
import ImageUI from 'ui/ImageUI';

interface Props {
  onClick?: () => void;
  icon?: string;
}

export const ProviderOption: FC<PropsWithChildren<Props>> = ({children, onClick, icon}) => {
  return (
    <Flex alignItems="center" justifyContent="center" position="relative">
      {children}
      <Button
        colorScheme="teal"
        variant="outline"
        bg={[colors.white, 'rgba(255, 255, 255, 0.15)']}
        border="1px solid"
        borderColor="rgba(255, 255, 255, 0.15)"
        w={['45px', '50px']}
        h={['10px', '50px']}
        _hover={{
          border: '1px solid',
        }}
        p="0px"
        _focus={{border: 'none'}}
        onClick={onClick}
      >
        {icon && <ImageUI zIndex={999} src={icon} alt="icon" />}
      </Button>
    </Flex>
  );
};
